/**
 * @description Wrapper for Axios response interceptor, catches any status codes within 2xx
 * @param {object} response The 2xx status response object
 */
function defaultResponseInterceptor (response) {
  if ((response.data && response.data.friendly) && response.data.friendly !== 'Ok') {
    return {
      ok: false,
      status: response.status ? response.status : 500,
      errors: Object.freeze([].concat(response.data.exception || [])),
      errorMessage: response.data.message || 'An error occurred while processing the request',
      data: null
    };
  } else {
    return {
      ok: true,
      status: response.status,
      errorMessage: null,
      data: [].concat(response.data || [])
    };
  }
}

export default defaultResponseInterceptor;
